import { render, staticRenderFns } from "./FlyerPricingImport.vue?vue&type=template&id=55ac8b6a"
import script from "./FlyerPricingImport.vue?vue&type=script&lang=js"
export * from "./FlyerPricingImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports